module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-256x256-7352ec4822d86c355fa3bde394fa8bd4.png";